module.exports = __webpack_public_path__ + "img/tjk.a8ed5244.svg";